<template>
  <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header modal-header-blue-bg">
          <div class="title-with-icon">
            <div class="title-with-icon__icon title-with-icon__icon-white title-with-icon__icon_exclamation"></div>
            <div class="title-with-icon__title">Подтверждение отмены</div>
          </div>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p class="content_22 mb-4">
            Вы точно хотите прекратить регистрацию на мероприятие? Все введенные данные будут утеряны.
          </p>
          <div class="d-flex justify-content-between align-items-center">
            <button type="button" class="btn btn-md btn-secondary" @click="no">Нет</button>
            <button type="button" class="btn btn-md btn-danger" @click="yes">Да</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
window.jQuery = $

export default {
  name: "OlympicsCancelConfirmModal",
  props: {
    id: {
      type: String,
      default: 'olympics-cancel-confirm-modal'
    },
    value: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    let self = this
    $('#' + this.id).on('hide.bs.modal', function () {
      // Удаляем только backdrop этого модального окна (последний)
      $('.modal-backdrop').last().remove();
      self.$emit('input', false)
    })
    
    // Обработчик для установки z-index backdrop при показе
    $('#' + this.id).on('shown.bs.modal', function () {
      // Подсчитываем количество backdrop'ов
      const backdropCount = $('.modal-backdrop').length;
      
      if (backdropCount === 1) {
        // Если backdrop один - z-index: 1040
        $('.modal-backdrop').attr('style', 'z-index: 1040 !important;');
      } else if (backdropCount === 2) {
        // Если backdrop'ов два - меняем их z-index
        $('.modal-backdrop').each(function(index) {
          if (index === 0) {
            // Первый backdrop (основное модальное окно) - 1040
            $(this).attr('style', 'z-index: 1040 !important;');
          } else {
            // Второй backdrop (модальное окно подтверждения отмены) - 1055
            $(this).attr('style', 'z-index: 1055 !important;');
          }
        });
      }
    })
  },
  watch: {
    value: {
      handler: async function(val) {
        if (val) {
          // При показе модального окна устанавливаем правильный z-index для backdrop
          $('#' + this.id).modal('show');
        } else {
          $('#' + this.id).modal('hide');
        }
      }
    }
  },
  methods: {
    no() {
      this.$emit('no')
      this.$emit('input', false)
    },
    yes() {
      this.$emit('yes')
      this.$emit('input', false)
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  z-index: 1060;
}

.modal-content {
  z-index: 1060;
}

.modal-body {
  padding: 2rem 4rem;
}
</style>

<style lang="scss">
// Глобальные стили для модального окна подтверждения отмены
#olympics-cancel-confirm-modal {
  z-index: 1060 !important;
}

#olympics-cancel-confirm-modal .modal-dialog {
  z-index: 1060 !important;
}

#olympics-cancel-confirm-modal .modal-content {
  z-index: 1060 !important;
}

// Убираем все CSS стили для backdrop - управляем только через JS
</style>
